import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Step1Email from './registration/Step1Email';
import Step2VerifyCode from './registration/Step2VerifyCode';
import Step3CompleteProfile from './registration/Step3CompleteProfile';
import AuthCardLeft from './AuthCardLeft';
import MobileDesktopOnlyModal from './MobileDesktopOnlyModal';
import './Auth.css';

const Register: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlan = (location.state as { selectedPlan?: string })?.selectedPlan;

  // Persist pending paid plan so PublicRoute can redirect to checkout after sign-in
  useEffect(() => {
    if (selectedPlan && selectedPlan !== 'starter') {
      localStorage.setItem('pendingPlan', selectedPlan);
    }
  }, [selectedPlan]);

  const handleStep1Complete = (userEmail: string) => {
    setEmail(userEmail);
    setCurrentStep(2);
  };

  const handleStep2Complete = () => {
    setCurrentStep(3);
  };

  const handleStep3Complete = () => {
    const dest = selectedPlan && selectedPlan !== 'starter'
      ? `/select-plan?plan=${selectedPlan}`
      : '/onboarding';

    // Fire Google Ads conversion event once on successful registration.
    // Use event_callback to ensure the pixel sends before navigating away.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17685768588/2O3iCJy4kcYbEIzTnfFB',
        value: 1.0,
        currency: 'USD',
        event_callback: () => navigate(dest),
      });
      // Fallback: navigate anyway if the callback doesn't fire within 1s
      setTimeout(() => navigate(dest), 1000);
    } else {
      navigate(dest);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="auth-container">
      <MobileDesktopOnlyModal />
      <Card className="auth-card">
        <Card.Body>
          <AuthCardLeft />
          <div className="auth-card-right">
            <div style={{ width: '100%', maxWidth: '400px' }}>
              {currentStep === 1 && (
                <Step1Email onComplete={handleStep1Complete} />
              )}
              {currentStep === 2 && (
                <Step2VerifyCode 
                  email={email} 
                  onComplete={handleStep2Complete}
                  onBack={handleBack}
                />
              )}
              {currentStep === 3 && (
                <Step3CompleteProfile 
                  email={email} 
                  onComplete={handleStep3Complete}
                  onBack={handleBack}
                />
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Register;